import { DateTime } from "luxon";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";

import { useGetOrg } from "../../../api/organizations/get-organization";
import { theme } from "../../../theme";

interface DateRangePickerProps {
  startFilter: DateTime | null;
  endFilter: DateTime | null;
  isStartValid: boolean;
  isEndValid: boolean;
  resourceMinTime: number;
  resourceMaxTime: number | undefined;
  onTimeChange: (newVal: DateTime | null, filterType: "start" | "end") => void;
}

export const DateRangePicker = ({
  startFilter,
  endFilter,
  resourceMinTime,
  onTimeChange,
  resourceMaxTime,
}: DateRangePickerProps) => {
  const org = useGetOrg();

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <Grid item container direction={"column"}>
        <Grid
          container
          direction={"row"}
          columnSpacing={1}
          rowSpacing={1}
          alignItems={"center"}
        >
          <Grid item>
            <DateTimePicker
              timezone={org?.data?.org?.timezone ?? "UTC"}
              slotProps={{
                digitalClockSectionItem: {
                  sx: {
                    "&.Mui-selected": {
                      backgroundColor: `${theme.igBackgroundColors.accentSolid} !important`,
                    },
                  },
                },
              }}
              disableFuture={true}
              minDateTime={DateTime.fromMillis(resourceMinTime)}
              label="Start Time"
              value={startFilter}
              onChange={(newValue) => {
                onTimeChange(newValue, "start");
              }}
              maxDateTime={
                resourceMaxTime
                  ? DateTime.fromMillis(resourceMaxTime)
                  : undefined
              }
            />
          </Grid>
          <Grid item>
            <IgTypography>to</IgTypography>
          </Grid>
          <Grid item>
            <DateTimePicker
              timezone={org?.data?.org?.timezone ?? "UTC"}
              slotProps={{
                digitalClockSectionItem: {
                  sx: {
                    "&.Mui-selected": {
                      backgroundColor: `${theme.igBackgroundColors.accentSolid} !important`,
                    },
                  },
                },
              }}
              disableFuture={true}
              label="End Time"
              minDateTime={DateTime.fromMillis(resourceMinTime)}
              value={endFilter}
              onChange={(newValue) => {
                onTimeChange(newValue, "end");
              }}
              maxDateTime={
                resourceMaxTime
                  ? DateTime.fromMillis(resourceMaxTime)
                  : undefined
              }
            />
          </Grid>
        </Grid>
        <Grid item mt={1}>
          <IgTypography variant={"body2"}>
            <IgTypography variant={"body2"} sx={{ fontWeight: 600 }}>
              Timezone:{" "}
            </IgTypography>
            {(org?.data?.org.timezone ?? "UTC").replaceAll("_", " ") || ""}
          </IgTypography>
        </Grid>
      </Grid>
    </LocalizationProvider>
  );
};
